import img from './steering.png';
import React from 'react';
import styled from '@emotion/styled';

const Icon = styled.img({
    height: '160px',
});

export type SteeringIconProps = {
    className?: string;
}

export const SteeringIcon = (props: SteeringIconProps) => {
    return (
        <Icon src={img} {...props} />
    );
};
